import { useContext } from "react";
import { userAuthContext } from "../../ContextAPI/isAuth";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./styles.css";
const Home = () => {
  const [isAuth] = useContext(userAuthContext);

  return (
    <motion.main
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      exit={{ opacity: 0 }}
      id="home"
      className="home"
    >
      <div className="container">
        <div className="home__container">
          <div className="home__welcome">
            <h1>
              dons
              <br />
              de sang
            </h1>
            <h4>
              <span>sauver des vies</span>
              <span className="dots">.......</span>
            </h4>
            <div className="quote">
              <p className="q">Ensemble, nous sommes forts</p>
              <p>
                Non seulement un médecin peut sauver une vie, mais nous pouvons
                aussi apporter notre petite contribution en donnant notre sang.
              </p>
            </div>
          </div>
          <div className="home__buttons">
            <div className="buttons_box">
              {isAuth ? (
                <>
                  <Link className="btn btn-primary" to="/findMatch">
                    {localStorage.getItem("tkn")["donator"]
                      ? "Trouver un nécessiteux"
                      : "Trouvez un donneur"}
                  </Link>
                </>
              ) : (
                <>
                  <Link className="btn btn-primary" to="/auth">
                    Dons
                  </Link>

                  <Link className="btn" to="/findmatch">
                    Trouver votre correspondance
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.main>
  );
};

export default Home;
